import {
    ApiHandler,
    UpdateIntegrationCredentialRequest,
    UpdateIntegrationSettingsRequest,
} from '@givelify/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { INTEGRATION_QUERY_KEY } from './useIntegration';

export const useIntegrationSettingsUpdate = () => {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async ({
            donorId,
            data,
        }: {
            donorId: number;
            data:
                | UpdateIntegrationSettingsRequest
                | UpdateIntegrationCredentialRequest;
        }) => {
            const isCredential = 'credentials' in data;
            const response = isCredential
                ? await ApiHandler.instance.donees.updateIntegrationCredential(
                      donorId,
                      data,
                  )
                : await ApiHandler.instance.donees.updateIntegrationSettings(
                      donorId,
                      data,
                  );
            return response;
        },
        onSuccess: (response, variables) => {
            if (response.success) {
                if (response.response.data.settings?.exportStartDate) {
                    response.response.data.settings.exportStartDate = dayjs(
                        response.response.data.settings.exportStartDate,
                    );
                } else if (
                    response.response.data.settings?.exportStartDate !==
                    undefined
                ) {
                    response.response.data.settings.exportStartDate = null;
                }
                queryClient.setQueryData(
                    [INTEGRATION_QUERY_KEY, variables.donorId],
                    response,
                );
            }
        },
    });

    const success =
        mutation.isIdle || mutation.isPending
            ? undefined
            : mutation.data?.success;
    const error =
        mutation.isIdle || mutation.isPending
            ? ''
            : mutation.data && !mutation.data.success
            ? mutation.data.error.message
            : '';

    return {
        ...mutation,
        success,
        error,
    };
};
